import * as React from 'react'
import { MessageBar, MessageBarType } from '@fluentui/react'
interface ErrorMessageBarProps {
    Message: string,
    onClose?: () => void;
}
export default ({ Message, onClose }: ErrorMessageBarProps) => {
    const [isShow, SetIsshow] = React.useState(!!Message);
    React.useEffect(() => {
        SetIsshow(!!Message)
    }, [Message])
    return (
        <>
            {(isShow) && (<MessageBar
                messageBarType={MessageBarType.severeWarning}
                isMultiline={true}
                dismissButtonAriaLabel="Close"
                onDismiss={() => {
                    SetIsshow(false);
                    if (onClose) {
                        onClose();
                    }
                }}
            >
                {Message}
            </MessageBar>)
            }
        </>
    );
}
